import { Base64 } from 'js-base64';

export const managerWhSortBy = [
  {
    value: 'label',
    lang: 'string13',
  },
  {
    value: 'windows',
    lang: 'string14',
  },
  {
    value: 'linux',
    lang: 'string15',
  },
  {
    value: 'status',
    lang: 'string8',
  },
  {
    value: 'primary_ip',
    lang: 'string17',
  },
  {
    value: 'backup_recent',
    lang: 'string18',
  },
  {
    value: 'backup_oldest',
    lang: 'string19',
  },
];

export const settingTabs = {
  upgrade: 'upgrade',
  actions: 'actions',
  'info/IPs': 'info/IPs',
  reverse_DNS: 'reverse_DNS',
  'templates/backups': 'templates/backups',
  bandwidth: 'bandwidth',
  payment_terms: 'payment_terms',
};

export const menuOptions = (rights, data) => {
  const dropdownItems = [
    {
      id: settingTabs.upgrade,
      name: 'Upgrade',
      name_lang: 'vs/instance.string56',
      show: rights.vschange && data?.billing_schedule == 'hourly',
    },
    {
      id: settingTabs.actions,
      name: 'Actions',
      name_lang: 'vs/instance.string57',
      show: rights.vsdelete || rights.vsresetpassword || rights.vsreinstall,
    },
    { id: settingTabs['info/IPs'], name: 'Info / IPs ', name_lang: 'vs/instance.string58' },
    { id: settingTabs.reverse_DNS, name: 'Reverse DNS', name_lang: 'vs/instance.string59' },
    { id: settingTabs['templates/backups'], name: 'Templates / Backups', name_lang: 'vs/instance.string60' },
    {
      show: data?.billing_schedule != 'hourly',
      id: settingTabs['payment_terms'],
      name: 'Payment terms',
      name_lang: 'vs/instance.string179',
    },
  ];
  return dropdownItems.filter((item) => (typeof item.show === 'undefined' ? true : item.show));
};

export const nextPageValidation = (data, queries) => Number(data?.meta?.how_many_pages) > Number(queries.page_number);
export const backPageValidation = (queries) => Number(queries?.page_number) > 1;
export const base64Label = (label) => (label ? Base64.atob(label) : label);

export const whDropDownItems = (setOpenConfigurationPanel) => {
  const dropdownArray = [
    {
      id: 0,
      name: 'upgrade',
      lang: 'wh/instance.string3',
      icon: 'fa fa-arrow-up',
      show: true,
      onClick: () => {},
    },
    {
      id: 1,
      name: 'start_container',
      lang: 'wh/instance.string4',
      icon: 'fa fa-play',
      show: true,
      onClick: () => {},
    },
    {
      id: 2,
      name: 'stop_container',
      lang: 'wh/instance.string5',
      icon: 'fa fa-stop-circle-o',
      show: true,
      onClick: () => {},
    },
    {
      id: 3,
      name: 'cancel_container',
      lang: 'wh/instance.string6',
      icon: 'fa fa-trash',
      show: true,
      onClick: () => {},
    },
    {
      id: 4,
      name: 'settings',
      lang: 'wh/instance.string7',
      icon: 'fa fa-cog',
      show: true,
      onClick: () => setOpenConfigurationPanel(true),
    },
  ];
  return dropdownArray.filter((res) => res.show);
};

export const disableStyles = { pointerEvents: 'none', opacity: 0.3 };

export const checkDeletedItems = (deletedIds, data) => {
  let Item = deletedIds.find((item) => item === data);
  if (Item) {
    return disableStyles;
  } else {
    return {};
  }
};
